module.exports = __webpack_public_path__ + "img/logo.48594884.png";